module.exports = __webpack_public_path__ + "static/img/b7.8837e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b7.jpg
// module id = sIoz
// module chunks = 1